module.exports = __webpack_public_path__ + "img/zypic.6d444fd9.png";